export default __webpack_public_path__ + "static/media/whatsapp.c262910f.png";